// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminProcedure_container__zISGU","text":"AdminProcedure_text__3yaG1","schedules":"AdminProcedure_schedules__1l9BG"};